import { useKeycloak } from "@react-keycloak/web";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { LoginScreen } from "./LoginScreen";

type PrivateRouteProps = {
  children: ReactElement
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { keycloak, initialized } = useKeycloak();
  const { t } = useTranslation();

  // Wait for Keycloak to finish its check-sso before rendering anything,
  // otherwise authenticated is briefly false and triggers the login UI on every refresh.
  if (!initialized) return null;

  // Check both localStorage and keycloak.authenticated to handle session expiration
  const isLoggedIn = keycloak?.authenticated && localStorage.getItem("userAuthorized") !== null;

  const handleLogin = () => {
    if (keycloak) {
      keycloak.login();
    }
  };

  return !isLoggedIn ? (
    <div className="fixed inset-0 z-[100] overflow-y-auto overflow-x-hidden">
      <LoginScreen
        title={t("Welcome to Gundi" as any)}
        subtitle={t("Please log in to continue" as any)}
        onLogin={handleLogin}
      />
    </div>
  ) : children;
};

export default PrivateRoute;
